import React from "react";

import * as Styled from "./error-message.style";

export const ErrorMessage = ({ text }) => (
  <Styled.ErrorMessage>{text}</Styled.ErrorMessage>
);

export default ErrorMessage;
